import React, { FC } from "react";
import { Patientportal_AppointmentProxyMsg } from "../../src/generated/graphql";
import { Maybe } from "@graphql-tools/utils/typings/types";
import { Col, Row, Space } from "antd";
import styles from "./appointment-card.module.scss";
import { useRouter } from "next/router";
import {
  buildAddress,
  buildTimestampDate,
  buildTimestampTime,
} from "../../helpers/formatters";

import {
  buildImageDownloadUrl,
  extractPrimaryAddress,
} from "../../helpers/utils";
import Image from "next/image";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  PushpinOutlined,
} from "@ant-design/icons";

interface AppointmentCardProps {
  appointmentProxy: Maybe<Patientportal_AppointmentProxyMsg> | undefined;
}

export const AppointmentCard: FC<AppointmentCardProps> = ({
  appointmentProxy,
}) => {
  const router = useRouter();

  const portalFacilities =
    appointmentProxy?.portalFacilityPath?.portalFacilities ?? [];

  const officeHour = portalFacilities?.[portalFacilities?.length - 1];

  const address = extractPrimaryAddress(officeHour?.contact);

  return (
    <div
      className={styles.appointmentCard}
      onClick={() =>
        router.push({
          pathname: "/appointments/appointment",
          query: {
            appointmentId: appointmentProxy?.appointment?.id,
            clinicId: appointmentProxy?.clinicId,
          },
        })
      }
    >
      <Space direction={"vertical"} style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col flex={"80px"}>
            <Image
              alt={officeHour?.name ?? "-"}
              src={
                officeHour?.logoImageId
                  ? buildImageDownloadUrl(officeHour?.logoImageId)
                  : "/image_placeholder.svg"
              }
              height={80}
              width={80}
              className={styles.doctorIcon}
            />
          </Col>
          <Col style={{ width: "calc(100% - 80px - 16px)" }}>
            <span>
              <b>
                {
                  appointmentProxy?.portalFacilityPath?.portalFacilities?.[0]
                    ?.name
                }
              </b>
            </span>
            <p>
              {
                appointmentProxy?.portalFacilityPath?.portalFacilities?.[1]
                  ?.name
              }
            </p>
            <span>
              <PushpinOutlined /> {buildAddress(address, true)}
            </span>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col span={24}>
            <div className={styles.date}>
              <CalendarOutlined style={{ marginRight: 10 }} />
              {buildTimestampDate(appointmentProxy?.appointment?.startTime)}
              <span style={{ float: "right" }}>
                <ClockCircleOutlined style={{ marginRight: 10 }} />
                {buildTimestampTime(appointmentProxy?.appointment?.startTime)}
              </span>
            </div>
          </Col>
        </Row>
      </Space>
    </div>
  );
};
